import { useContext } from 'react';

import Grid from '@mui/material/Grid';
import Divider from '@mui/material/Divider';
import Card from '@mui/material/Card';
import { Container, Stack, Typography } from '@mui/material';

import ArgonBox from 'component/Argon/ArgonBox';
import ArgonTypography from 'component/Argon/ArgonTypography';

import FormContext from './ContextForm';

import {
  InputName,
  SelectPrefix,
  PickerBd,
  PickerPolicyDate,
  SelectCountry,
  SelectPkg,
  SelectCardType,
  InputEmployer,
  InputEmployerId,
  InputAddress1,
  AutoCompleteDistrict,
  FormField,
} from 'component/basicForm';
import InputLabel from 'component/basicForm/InputLabel';
import ArgonButton from 'component/Argon/ArgonButton';
import FormLabel from 'page/insurance-excel/components/FormLabel';
import SelectAddress from 'page/insurance-excel/components/SelectAddress';
import FormDialog from './components/FormDialog';

function LayoutForm() {
  const { formData: state, resetState, disabled, firstValidate, setOpen } = useContext(FormContext);

  const onCommit = (value) => {
    if (value) {
      const curr = value;
      state.setArea(curr?.amphoe);
      state.setProvince(curr?.province);
      state.setZipcode(curr?.zipcode.toString());
    }
  };

  return (
    <>
      <Container>
        <ArgonBox mb={2}>
          <Typography variant="h4" color="primary.contrastText" fontWeight={500}>
            ซื้อประกันภัย
          </Typography>
          <Typography variant="body2" color="primary.contrastText">
            สร้างข้อมูลกรมธรรม์
          </Typography>
        </ArgonBox>
        <Grid container spacing={1}>
          <Grid item xs={9}>
            <Card sx={{ p: 3 }}>
              <Grid container spacing={1}>
                <Grid item xs={12}>
                  <ArgonTypography component="label" variant="body2" fontWeight="bold">
                    ส่วนที่ 1: ข้อมูลแรงงาน
                  </ArgonTypography>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <SelectPrefix value={state.prefix} setValue={state.setPrefix} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <InputName value={state.name} setValue={state.setName} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <PickerBd value={state.bd} setValue={state.setBd} />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <SelectCountry value={state.nationality} setValue={state.setNationality} />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <PickerPolicyDate value={state.policyDate} setValue={state.setPolicyDate} />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <SelectPkg value={state.pkg} setValue={state.setPkg} />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <InputLabel
                    label={
                      <Stack direction="row">
                        เลขที่ประจำตัว
                        <ArgonBox ml={3}>
                          <ArgonTypography variant="caption" fontWeight="bold" color="error">
                            ***ซื้อประกันเพื่อใช้ต่ออายุใบอนุญาตทำงาน ในช่องเลขที่ประจำตัวให้ใส่ เลขรหัสต่างด้าว13หลัก
                            เท่านั้น***
                          </ArgonTypography>
                        </ArgonBox>
                      </Stack>
                    }
                    placeholder="เลขที่พาสปอร์ต / เลขที่ Work Permit / เลขที่ CI No. / TD No. / เลขที่ใบแทนอนุญาตทำงาน (บต.23, 39, 48)"
                    value={state.idCard}
                    setValue={state.setIdCard}
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <SelectCardType
                    value={state.cardType}
                    setValue={state.setCardType}
                    label={
                      <Stack direction="row">
                        <ArgonTypography variant="caption" fontWeight="bold">
                          ประเภทเลขที่ประจำตัว
                        </ArgonTypography>
                        <ArgonBox ml={3}>
                          <ArgonTypography variant="caption" fontWeight="bold" color="error">
                            ***ซื้อประกันเพื่อใช้ต่ออายุใบอนุญาตทำงาน ให้เลือกประเภทเลขที่ประจำตัวเป็นเลขที่ Work
                            Permit*
                          </ArgonTypography>
                        </ArgonBox>
                      </Stack>
                    }
                  />
                </Grid>
              </Grid>
            </Card>
            <Grid item xs={12} lg={12} mb={32} mt={2}>
              <Card sx={{ p: 3 }}>
                <ArgonBox>
                  <Stack direction="row" alignContent="center" justifyContent="space-between">
                    <FormLabel title="ที่อยู่" subtitle="เลือกที่อยู่ที่ต้องการ" />
                    <ArgonBox lineHeight={1}>
                      <Stack direction="row" alignItems="center" spacing={1}>
                        <ArgonButton
                          size="small"
                          variant="gradient"
                          color="info"
                          onClick={() => {
                            setOpen(true);
                          }}
                        >
                          เพิ่ม
                        </ArgonButton>
                      </Stack>
                    </ArgonBox>
                  </Stack>
                </ArgonBox>

                <SelectAddress options={state.addresses} setValue={state.setAddress} value={state.address} />
                {/* <ActionButton /> */}
              </Card>
            </Grid>
          </Grid>

          <Grid item xs={3}>
            <Card sx={{ p: 3, gap: 2 }}>
              <Typography variant="h6">เมนู</Typography>
              <ArgonButton variant="gradient" color="error" onClick={resetState}>
                ล้างฟอร์ม
              </ArgonButton>
              <ArgonButton
                variant="gradient"
                color="success"
                disabled={disabled}
                onClick={() => {
                  firstValidate();
                }}
              >
                ยืนยัน
              </ArgonButton>
            </Card>
          </Grid>
        </Grid>
      </Container>
      <FormDialog />
    </>
  );
}

export default LayoutForm;
